/**
 * Fallback UI for `ApplicationErrorBoundary`. Relies on the surrounding app `IntlProvider`
 * (`FormattedMessage`). Primary action: full page reload. SSAP Final Review uses
 * `SsapSummaryFallback` instead (targeted summary refresh via Redux).
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@cmsgov/design-system';

import ClientErrorFallbackLayout from './ClientErrorFallbackLayout';

function getStateCode(getState) {
    try {
        return getState?.()?.common?.environment?.stateCode;
    } catch {
        return null;
    }
}

const ApplicationErrorFallback = ({ getState, onReload }) => {
    const stateCode = (getStateCode(getState) || 'gi').toString();

    return (
        <ClientErrorFallbackLayout
            mainId="gi-application-error-fallback__container"
            headerId="application-error-header"
            stateCode={stateCode}
        >
            <Button className="usa-button gi-button gi-button__primary" type="button" onClick={onReload}>
                <FormattedMessage id="application.error_boundary.reload_page" />
            </Button>
        </ClientErrorFallbackLayout>
    );
};

export default ApplicationErrorFallback;
